import './rotas/autenticacao.rotas'
import AutenticacaoStore from './store/autenticacao.store'

export default AutenticacaoStore
